import styles from './NotFound.module.css';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../../Components/NavBar/NavBar';
import Login from '../../Components/Login/Login';
import AnimatedHome from '../AnimatedPage/AnimatedHome';
import { motion } from "framer-motion";
import { t } from "../../utils/i18n";

const NotFound = props => {
  const {
    cartDisplayed,
    handleCloseCart,
    handleOpenLogin,
    handleLoginSuccess,
    handleLogout,
    isLoggedIn,
    cartAmount,
    clearCart,
    hoverState,
    handleHome,
    handleHover,
    handleBrowse,
    cart,
    browsing,
    landingPage,
    search,
    searching,
    handleSearch,
    handleSearchSubmit,
    handleRemoveFromCart,
    openGamePage
  } = props;
  const location = useLocation();

  const animations = {
    initial: { opacity: 0, y: -225 },
    animate: { opacity: 1, y: 0, transition: { y: { type: "spring", duration: 1.5, bounce: 0.5 }} },
    exit: { opacity: 0, y: -175, transition: { y: { type: "tween", duration: 0.675, bounce: 0.5 }, opacity: { type: "tween", duration: 0.675 }} },
}

const progress = {
  initial: { width: 0 },
  animate: { width: 700, transition: { width: { type: "tween", duration: 7 }} },
}

useEffect(() => {
  setTimeout(handleBrowse, 6800);
}, [])

    return (
      <div className={styles.notFound}>
          {cartDisplayed ? <Login 
            cartDisplayed={cartDisplayed} 
            handleCloseCart={handleCloseCart}
            onLoginSuccess={handleLoginSuccess}
            handleHover={handleHover}
            hoverState={hoverState}
          /> : null}

          <NavBar
            handleHover={handleHover}
            hoverState={hoverState}
            handleHome={handleHome}
            browsing={browsing}
            landingPage={landingPage}
            cartAmount={cartAmount}
            search={search}
            searching={searching}
            handleSearch={handleSearch}
            handleSearchSubmit={handleSearchSubmit}
            handleOpenLogin={handleOpenLogin}
            handleCloseCart={handleCloseCart}
            isLoggedIn={isLoggedIn}
            handleLogout={handleLogout}
           />

            <motion.div className={styles.container} variants={animations} initial="initial" animate="animate" exit="exit">
                <div className={styles.notFoundContent}>
                    <img className={styles.notFoundImg} src={require("../../Resources/image/404.png")} alt="Not Found Warning" />
                    <div className={styles.notFoundText}>
                        <h2>
                          {t("notFound.title", "{path} is not available!", {
                            path: location.pathname.substring(9),
                          })}
                        </h2>
                        <p>
                          {t(
                            "notFound.message",
                            "The page you tried to access is not available. You will be redirected to our browse section shortly. If you think this is an error,",
                          )}{" "}
                          <span className={styles.contact}>
                            {t("notFound.contact", "contact us!")}
                          </span>
                        </p>
                    </div>
                </div>
                <motion.div className={styles.progressBar} variants={progress} initial="initial" animate="animate"></motion.div>
            </motion.div>
    
      </div>
    );
  }
  
  export default NotFound;